// Vehicle Models — display & spec templates shared across multiple vehicles.
// A vehicle assigned to a model inherits: photos, features, transmission,
// fuelType, seats, mileage, priceDay, deposit, contractId, groupId.
// The vehicle keeps its own plate, status, odometer, motExpiry.

export const initialVehicleModels = [
  // Example structure (commented for reference)
  // {
  //   id: 'm-corolla-hybrid',
  //   name: 'Toyota Corolla Hybrid',
  //   icon: '🚗',
  //   photos: [],            // base64 data URLs (up to 5)
  //   features: 'A/C, GPS, Bluetooth, USB',
  //   transmission: 'Automatic',
  //   fuelType: 'Hybrid',
  //   seats: '5 seats',
  //   mileage: 'Unlimited',
  //   priceDay: 45,
  //   deposit: 500,
  //   contractId: null,      // agreement template id (optional)
  //   groupId: null,         // pricing/rate-rules group id (optional)
  //   type: 'Car',           // vehicle type
  // },
];
